import { CfAnchorProps } from "./schema";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { LiveInspectorData } from "types/types";
import { Poly } from "components/Poly";
import { convertToPolyLink } from "./utils";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { useUpdateModal } from "utilities/ModalProvider";
import React from "react";

const CfAnchor = ({ children, ...props }: CfAnchorProps) => {
  const { livePreview = false, ...anchor } = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  const liveInspector: LiveInspectorData = livePreview
    ? {
        poly: ContentfulLivePreview.getProps({
          entryId: props.contentful_id,
          fieldId: "poly",
        }),
      }
    : undefined;

  const idModal = anchor.modal?.id;
  const { openModal } = useUpdateModal();
  const onClick = () => {
    if (idModal && openModal) openModal(idModal);
  };

  let linkProps = convertToPolyLink(anchor);

  if (anchor.anchorType === "openModal")
    linkProps = { ...linkProps, onClick, onKeyDown: onClick };

  return anchor.anchorType ? (
    <Poly {...linkProps} liveInspector={liveInspector}>
      {children}
    </Poly>
  ) : (
    children
  );
};

export default CfAnchor;

CfAnchor.displayName = "CfAnchor";
